module.exports = __webpack_public_path__ + "img/education-bg.73da14ee.png";